import "core-js/modules/es.array.includes.js";
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "question-item"
};
var _hoisted_2 = ["innerHTML"];
var _hoisted_3 = {
  key: 0,
  class: "question-list"
};
var _hoisted_4 = ["innerHTML"];
export default {
  __name: 'question',
  props: {
    exercisesData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _props$exercisesData;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "question-title",
        innerHTML: (_props$exercisesData = __props.exercisesData) === null || _props$exercisesData === void 0 ? void 0 : _props$exercisesData.content
      }, null, 8, _hoisted_2), ['SINGLE_CHOICE', 'MULTIPLE_CHOICE'].includes(__props.exercisesData.type) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.exercisesData.options, function (option) {
        return _openBlock(), _createElementBlock("li", {
          key: option.sign
        }, [_createElementVNode("span", null, _toDisplayString(option.code) + ".", 1), _createElementVNode("span", {
          innerHTML: option.content
        }, null, 8, _hoisted_4)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    };
  }
};